// GSAP Parallax Effect - Using global GSAP from CDN
// GSAP is loaded via CDN in functions.php

// Global instance tracker
let gsapParallaxInstance = null;

// Function to reset all parallax images to their default state
function resetParallaxImages() {
    const parallaxImages = document.querySelectorAll('[data-parallax]');
    parallaxImages.forEach(image => {
        image.style.transform = '';
        image.style.translate = '';
        image.style.rotate = '';
        image.style.scale = '';
    });
}

class GSAPParallax {
    constructor() {
        this.parallaxImages = document.querySelectorAll('[data-parallax]');

        if (this.parallaxImages.length === 0) {
            return;
        }

        // Check if window is wide enough for parallax
        if (window.innerWidth < 950) {
            return;
        }

        // Check if GSAP is available
        if (typeof gsap === 'undefined') {
            console.warn('GSAP not loaded');
            return;
        }

        this.init();
    }

    init() {
        this.parallaxImages.forEach((image, index) => {
            const speed = parseFloat(image.dataset.parallax) || 0.8;
            const parentElement = image.parentElement;

            // Use a percentage-based approach for more dramatic effect
            const elementHeight = image.offsetHeight;
            const parallaxDistance = Math.min(elementHeight * speed * 0.3, 150); // max 150px

            // Use setTimeout to ensure element is fully ready
            setTimeout(() => {

                // Clear any existing transforms and set initial state
                image.style.transform = '';
                image.style.translate = '';
                image.style.rotate = '';
                image.style.scale = '';

                // Force hardware acceleration and set initial state with scale
                gsap.set(image, {
                    y: parallaxDistance,
                    scale: 1.1, // Scale up to prevent white space
                    force3D: true,
                    immediateRender: true
                });

                // Create GSAP parallax animation using fromTo with proper height calculations
                gsap.fromTo(
                    image,
                    {
                        y: parallaxDistance, // Start position
                        scale: 1.1 // Maintain scale throughout animation
                    },
                    {
                        y: -parallaxDistance, // End position (move in opposite direction)
                        scale: 1.1, // Keep scale constant
                        ease: "none",
                        force3D: true, // Force hardware acceleration
                        immediateRender: false, // Don't render immediately for fromTo
                        scrollTrigger: {
                            trigger: parentElement,
                            start: "top bottom",
                            end: "bottom top",
                            scrub: 0.5,
                            onUpdate: (self) => {

                            }
                        }
                    }
                );

            }, 100); // Small delay to ensure element is ready
        });

    }

    // Method to refresh parallax (useful for dynamic content)
    refresh() {
        if (typeof gsap !== 'undefined' && gsap.ScrollTrigger) {
            gsap.ScrollTrigger.refresh();
        }
    }

    // Method to kill all parallax animations
    kill() {
        if (typeof gsap !== 'undefined' && gsap.ScrollTrigger) {
            gsap.ScrollTrigger.killAll();
        }
    }
}

// Function to handle parallax initialization based on window size
function handleParallaxInit() {
    if (window.innerWidth >= 950) {
        if (!gsapParallaxInstance) {
            gsapParallaxInstance = new GSAPParallax();
        }
    } else {
        if (gsapParallaxInstance) {
            gsapParallaxInstance.kill();
            gsapParallaxInstance = null;
        }
        resetParallaxImages();
    }
}

// Initialize GSAP parallax when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    handleParallaxInit();
});

// Also try initializing on window load
window.addEventListener('load', () => {
    handleParallaxInit();
});

// Handle window resize
window.addEventListener('resize', () => {
    setTimeout(() => {
        handleParallaxInit();
        if (typeof gsap !== 'undefined' && gsap.ScrollTrigger) {
            gsap.ScrollTrigger.refresh();
        }
    }, 100);
});

// Pause parallax on reduced motion preference
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.addEventListener('DOMContentLoaded', () => {
        if (gsapParallaxInstance) {
            gsapParallaxInstance.kill();
            gsapParallaxInstance = null;
        }
        resetParallaxImages();
    });
} 